import axios from 'axios'
import $api from '@/api/urls'
// 创建一个 axios 实例，设置基础 URL 和默认配置
const apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem('token')
  },
  timeout: 10000
})

// 身份验证相关服务
const authService = {
  // 获取验证码
  getCaptcha() {
    let time = new Date().getTime();
    return axios.get($api.GET_CAPTCHA + `?timestamp=${time}`,{responseType: "arraybuffer",}).then(res => {
      let imgData = {};
      imgData.data = 'data:image/png;base64,' + btoa(
        new Uint8Array(res.data)
        .reduce((data, byte) => data + String.fromCharCode(byte), '')
      );
      imgData.header = res.headers;
      return imgData
    })
    .then(data => {
      return  data;
    })
  },
  
  // 发送短信验证码
  sendSmsCode(phoneData,header) {
    return axios.get($api.SEND_SMS_CODE, { params: phoneData ,headers:header})
  },
  //注册发送短信验证码
  sendSmsCodeRegister(phoneData,header) {
    return axios.get($api.SEND_SMS_CODE_REGISTER, { params: phoneData ,headers:header})
  },
  
  // 登录
  login(credentials) {
    return apiClient.post($api.LOGIN, credentials)
  },
  
  // 注册-登录
  registerLogin(userData) {
    return apiClient.post($api.REGISTER_LOGIN, userData)
  },
  //修改个人信息
  registerInfo(userData,header) {
    return apiClient.post($api.REGISTER_INFO, userData,{headers:header})
  }
}

export default authService 